
import { SiGithub, SiGmail, SiGooglescholar, SiOrcid } from "react-icons/si";
import { useState } from 'react';
import { LinkedinPlain } from "devicons-react";
function GithubIcon() {
  const [active, setActive] = useState(false);
  return (
    <a rel="noreferrer" href="https://github.com/ciaccogiuseppe" target="_blank">
      <SiGithub 
      size={25}
      color={active? "#aeced2" : "#6c8799"}
      style={{marginRight:20, cursor:"pointer"}}
      onMouseOver={()=>setActive(true)}
      onMouseLeave={()=>setActive(false)}/>
    </a>
  );
}
function LinkedinIcon() {
  const [active, setActive] = useState(false);
  return (
    <a rel="noreferrer" href="https://www.linkedin.com/in/ciaccogiuseppe" target="_blank">
      <LinkedinPlain 
      size={25}
      color={active? "#aeced2" : "#6c8799"}
      style={{marginRight:20, cursor:"pointer"}}
      onMouseOver={()=>setActive(true)}
      onMouseLeave={()=>setActive(false)}/>
    </a>
  );
}
function ScholarIcon() {
  const [active, setActive] = useState(false);
  return (
    <a rel="noreferrer" href="https://scholar.google.com/citations?user=Lvti-dkAAAAJ&hl=it" target="_blank">
      <SiGooglescholar 
      size={25}
      color={active? "#aeced2" : "#6c8799"}
      style={{marginRight:20, cursor:"pointer"}}
      onMouseOver={()=>setActive(true)}
      onMouseLeave={()=>setActive(false)}/>
    </a>
  );
}
function ORCIDIcon() {
  const [active, setActive] = useState(false);
  return (
    <a rel="noreferrer" href="https://orcid.org/0009-0008-0427-4259" target="_blank">
      <SiOrcid 
      size={25}
      color={active? "#aeced2" : "#6c8799"}
      style={{marginRight:20, cursor:"pointer"}}
      onMouseOver={()=>setActive(true)}
      onMouseLeave={()=>setActive(false)}/>
    </a>
  );
}
function MailIcon() {
  const [active, setActive] = useState(false);
  return (
    <a rel="noreferrer" href= "mailto:giuseppeciacco.gc@gmail.com" target="_blank">
      <SiGmail 
      size={25}
      color={active? "#aeced2" : "#6c8799"}
      style={{marginRight:0, cursor:"pointer"}}
      onMouseOver={()=>setActive(true)}
      onMouseLeave={()=>setActive(false)}/>
    </a>
  );
}
function CVIcon() {
  const [active, setActive] = useState(false);
  return (
    <a 
    onMouseOver={()=>setActive(true)}
    onMouseLeave={()=>setActive(false)} rel="noreferrer" href= "https://github.com/ciaccogiuseppe/ciaccogiuseppe.github.io/blob/main/CV_CIACCO_2024.pdf" target="_blank">
      
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="30"
        width="30"
        viewBox="0 0 45 45"
        scale={0.5}
        fillRule="evenodd"
        style={{cursor:"pointer", marginLeft:1, marginRight:1}}
      >
        <g>
          <g>
            <path fill={active? "#aeced2" : "#6c8799"} d="M19.558 25.389a1.524 1.524 0 01-.264.455c-.108.129-.24.229-.396.301a1.358 1.358 0 01-.57.107c-.313 0-.572-.068-.78-.203a1.507 1.507 0 01-.498-.541 2.606 2.606 0 01-.27-.756 4.252 4.252 0 01-.084-.852c0-.289.027-.572.084-.853.056-.281.146-.533.27-.756.124-.225.29-.404.498-.541.208-.137.468-.203.78-.203.271 0 .494.051.666.154.172.105.31.225.414.361.104.137.176.273.216.414.04.139.068.25.084.33h2.568c-.112-1.08-.49-1.914-1.135-2.502-.644-.588-1.558-.887-2.741-.895-.664 0-1.263.107-1.794.324-.532.215-.988.52-1.368.912-.38.392-.672.863-.876 1.416a5.262 5.262 0 00-.307 1.836c0 .631.097 1.223.288 1.77.192.549.475 1.021.847 1.422s.825.717 1.361.949c.536.23 1.152.348 1.849.348.624 0 1.18-.105 1.668-.312.487-.209.897-.482 1.229-.822s.584-.723.756-1.146c.172-.422.259-.852.259-1.283h-2.593c-.039.2-.092.391-.161.566z"></path>
            <path fill={active? "#aeced2" : "#6c8799"} d="M26.62 24.812L26.596 24.812 25.192 19.616 22.528 19.616 25.084 28.184 28.036 28.184 30.713 19.616 28 19.616z"></path>
            <path fill={active? "#aeced2" : "#6c8799"} d="M33.431 0H5.179v45.057h34.699V6.251L33.431 0zm3.447 42.056H8.179V3h23.706v4.76h4.992l.001 34.296z"></path>
          </g>
        </g>
        </svg>
        <span style={{fontSize:13}}>Download resume</span>
    </a>
  );
}

export {GithubIcon, LinkedinIcon, ScholarIcon, ORCIDIcon, MailIcon, CVIcon};